import { Component } from "react";
import {
  getEvent,
  savePaidBooking,
  saveFreeBooking,
} from "../../actions/bookingAction";
import { notification, withRouter } from "../../utils/utility";
import { connect } from "react-redux";
import BookingStep1 from "./booking-step-1";
import BookingStep2 from "./booking-step-2";
import BookingStep3 from "./booking-step-3";
import BookingStep4 from "./booking-step-4";
import Three from "../../assets/bookingeventassets/assets/3.jpg";

import "../../assets/bookingeventassets/booking.scss";

import "../../assets/bookingeventassets/calender/fonts/icomoon/style.css";
import "../../assets/bookingeventassets/calender/css/rome.css";
import "../../assets/bookingeventassets/calender/css/style.css";

import logo from "../../assets/bookingeventassets/assets/logo.svg";
import SideLogo from "../../assets/bookingeventassets/assets/sidelogo.svg";
import SideBarFootLogo from "../../assets/bookingeventassets/assets/side_bar_foot_logo.svg";
import { getDBFormatedDate, IMAGE_BASE_URL } from "../../utils/utility";
import isEmpty from "../../validation/is-empty";
import Loader from "../../components/Loader/Loader";
import ErrorPage from "../errors/ErrorPage";
import { sendPostRequest } from "../../actions/app-actions";

class Booking extends Component {
  state = {
    isLoading: false,
    step: 1,
    event: {},
    company: {},
    paymentSettings: null,
    selectedStaffId: null,
    selectedSlot: null,
    endSlotTime: null,
    bookingDate: null,
    firstName: null,
    lastName:null,
    email: null,
    messageFromCustomer: null,
    reminderPhoneNo: null,
    inviteeGuests: [],
    questionAnswers: [],
    timezondId: "",
    timezoneValue: "",
    addOns: [],
    pricing: [],
    specialRibbon: null,
    totalPrice: 0,
    error: null,
    bookingId: null
  };

  /**
   * on step two submit handler
   * @param {*} name
   * @param {*} email
   * @param {*} messageFromCustomer
   */
  onSubmitStepTwo = (
    firstName,
    lastName,
    email,
    messageFromCustomer,
    reminderPhoneNo,
    inviteeGuests,
    questionAnswers,
    addOns = [],
    pricing = [],
    isEventPaid = "E"
  ) => {
    const _this = this;
    this.setState(
      {
        firstName,
        lastName,
        email,
        messageFromCustomer,
        reminderPhoneNo,
        inviteeGuests,
        questionAnswers,
        addOns,
        pricing,
      },
      () => {
        if (isEventPaid === "D") {
          _this.onScheduleEvent({});
        } else {
          _this.postTempBooking();
        }
      }
    );
  };



  /**
   * on select staff
   * @param {*} staffId
   */
  onSelectStaff = (staffId) => {
    this.setState({ selectedStaffId: staffId });
  };

  /**
   * on select timezone
   */
  onSelectTimzone = (timezondId, timezoneValue) => {
    this.setState({ timezondId, timezoneValue });
  };

  /**
   * on update step
   * @param {*} step
   */
  onUpdateStep = (step) => {
    this.setState({
      step,
    });
  };

  /**
   * on select slot
   * @param {*} slot
   */
  onSelectSlot = (slot) => {
    this.setState({
      selectedSlot: slot,
    });
  };

  /**
   * on calendar date select
   * @param {*} date
   */
  onSelectDate = (date) => {
    this.setState({
      bookingDate: getDBFormatedDate(new Date(date)),
    });
  };

  /**
   * save booking in temp status
   */
  postTempBooking = () => {
    const _this = this;
    const {
      firstName,
      lastName,
      email,
      messageFromCustomer,
      reminderPhoneNo,
      questionAnswers,
      selectedStaffId,
      selectedSlot,
      event,
      bookingDate,
      company,
      addOns,
      pricing,
      timezoneValue,
      inviteeGuests,
    } = this.state;

    const bookingDateTime = bookingDate + " " + selectedSlot;

    _this.setState({
      isLoading: true,
    });

    // calculate slot end time
    let endDate = new Date(bookingDateTime);
    if (!isNaN(event.timeslot)) {
      endDate.setTime(endDate.getTime() + event.timeslot * 60 * 1000);
    }

    const endSlot =
      ("0" + endDate.getHours()).slice(-2) +
      ":" +
      ("0" + endDate.getMinutes()).slice(-2);

    _this.setState({
      endSlotTime: endSlot,
    });

    let bookingDetails = {
        event_id: event.id,
        booking_date_time: bookingDateTime,
        start_time: selectedSlot + ":00",
        end_time: endSlot + ":00",
        message_from_customer: messageFromCustomer,
        reminder_phone_no: reminderPhoneNo,
        business_id: company.business_id,
        timezone: timezoneValue,
        email: email,
        first_name: firstName,
        last_name: lastName,
        booking_addons: [...addOns],
        booking_pricing: [...pricing],
        questions: [...questionAnswers],
        invitee_guests: inviteeGuests
    };

    if (!isEmpty(selectedStaffId)) {
        bookingDetails.staff_id = selectedStaffId;
    }

    _this.props.sendPostRequest({
      url: `/booking/post-temp-booking`,
      data: {
        ...bookingDetails,
      },
      onSuccess: (data) => {
        if (data.success) {
          _this.setState({
            isLoading: false,
            bookingId: data.data.id
          });
          _this.onUpdateStep(3);
        }
      },
      onError: (error) => {
        _this.setState({
          isLoading: false,
        });

        if (!isEmpty(error?.response?.data?.message)) {
          notification.error(error?.response?.data?.message);
        } else if (!isEmpty(error?.response?.statusText)) {
          notification.error(error?.response?.statusText);
        } else {
          notification.error("An Error occurred duing saving, please try later");
        }
      },
    });
  }

  /**
   * confirm temp booking to active booking
   * @param {*} data 
   */
  postConfirmTempBooking = (data) => {
    const _this = this;
    const {
      selectedSlot,
      event,
      bookingDate,
      company,
      timezoneValue,
      bookingId
    } = this.state;

    const bookingDateTime = bookingDate + " " + selectedSlot;
    // calculate slot end time
    let endDate = new Date(bookingDateTime);
    if (!isNaN(event.timeslot)) {
      endDate.setTime(endDate.getTime() + event.timeslot * 60 * 1000);
    }

    const endSlot =
      ("0" + endDate.getHours()).slice(-2) +
      ":" +
      ("0" + endDate.getMinutes()).slice(-2);

    _this.setState({
      endSlotTime: endSlot,
      totalPrice: data.totalPrice,
      isLoading: true,
    });

    let bookingDetails = {
      event_id: event.id,
      booking_id: bookingId,
      payment_method:data.paymentMethod,
      business_id: company.business_id,
      timezone: timezoneValue,
      coupon_code: data.couponCode,
      booking_date_time: bookingDateTime,
      start_time: selectedSlot + ":00",
      end_time: endSlot + ":00",
      total_price: data.totalPrice,
    };

    if (data.paymentMethod === "card") {
      bookingDetails.stripe_payment_method_id = data.stripePaymentMethodId; 
    } else if (data.paymentMethod == "paypal") {
      bookingDetails.paypal_order_id = data.paypalOrderId;
      bookingDetails.paypal_capture_id = data.paypalCaptureId;
    }
      
    _this.props.sendPostRequest({
      url: `/booking/post-confirm-temp-booking`,
      data: {
        ...bookingDetails,
      },
      onSuccess: (data) => {
        if (data.success) {
          _this.setState({
            isLoading: false
          });
          _this.onUpdateStep(4);
        }
      },
      onError: (error) => {
        _this.setState({
          isLoading: false,
        });
        if (!isEmpty(error?.response?.data?.message)) {
          notification.error(error?.response?.data?.message);
        } else if (!isEmpty(error?.response?.statusText)) {
          notification.error(error?.response?.statusText);
        } else {
          notification.error("An Error occurred duing saving, please try later");
        }
      },
    });

  }

  /**
   * on schedule event
   * @param {*} data
   */
  onScheduleEvent = (data) => {
    const _this = this;
    const {
      firstName,
      lastName,
      email,
      messageFromCustomer,
      reminderPhoneNo,
      questionAnswers,
      selectedStaffId,
      selectedSlot,
      event,
      bookingDate,
      company,
      addOns,
      pricing,
      timezoneValue,
      inviteeGuests,
    } = this.state;

    _this.setState({
      isLoading: true,
    });

    /*
    console.log("addons", data.addOns);
    console.log("pricing", data.pricing);
    console.log("card details", data.cardDetails);
    console.log("name", name);
    console.log("email", email);
    console.log("messageFromCustomer", messageFromCustomer);
    console.log("questionAnswers", questionAnswers);
    console.log("selectedStaffId", selectedStaffId);
    console.log("selectedSlot", selectedSlot);
    console.log("booking date", bookingDate);
    */

    // calculate booking date and time
    const bookingDateTime = bookingDate + " " + selectedSlot;
    //console.log("booking date and time", bookingDateTime);

    // calculate slot end time
    let endDate = new Date(bookingDateTime);
    if (!isNaN(event.timeslot)) {
      endDate.setTime(endDate.getTime() + event.timeslot * 60 * 1000);
    }

    const endSlot =
      ("0" + endDate.getHours()).slice(-2) +
      ":" +
      ("0" + endDate.getMinutes()).slice(-2);

    _this.setState({
      endSlotTime: endSlot,
    });
    // save free event
    const { saveFreeBooking } = this.props;
    let bookingDetails = {
      event_id: event.id,
      booking_date_time: bookingDateTime,
      start_time: selectedSlot + ":00",
      end_time: endSlot + ":00",
      message_from_customer: messageFromCustomer,
      reminder_phone_no: reminderPhoneNo,
      business_id: company.business_id,
      timezone: timezoneValue,
      email: email,
      first_name: firstName,
      last_name: lastName,
      questions: [...questionAnswers],
      invitee_guests: inviteeGuests,
    };

    if (!isEmpty(selectedStaffId)) {
      bookingDetails.staff_id = selectedStaffId;
    }

    saveFreeBooking({
      data: {
        ...bookingDetails,
      },
      onSuccess: (data) => {
        _this.setState({
          isLoading: false,
        });
        _this.onUpdateStep(4);
        console.log("data", data);
      },
      onError: (error) => {
        _this.setState({
          isLoading: false,
        });
      },
    });
  };

  /**
   * execute when component inserted in dom
   */
  componentDidMount() {
    const _this = this;
    const { router, getEvent } = this.props || {};
    const { params } = router || {};
    const { slug } = params || {};

    _this.setState({ isLoading: true });

    getEvent({
      data: {
        slug,
      },
      onSuccess: function (response) {
        if (isEmpty(response.company)) {
          _this.setState({
            isLoading: false,
            error: "Company information is missing!",
          });
          return;
        }

        _this.setState({
          isLoading: false,
          event: response.event,
          company: response.company,
          specialRibbon: !isEmpty(response.special_ribbon)
            ? response.special_ribbon.special_announcement
            : null,
          paymentSettings: response.payment_settings
        });
      },
      onError: (error) => {
        _this.setState({
          isLoading: false,
          error: "This event is invalid or no longer available",
        });
        notification.error(error.response.data.message);
      },
    });
  }

  render() {
    const {
      step,
      event,
      company,
      selectedSlot,
      endSlotTime,
      bookingDate,
      timezoneValue,
      addOns,
      pricing,
      specialRibbon,
      totalPrice,
      isLoading,
      inviteeGuests,
      error,
      firstName,
      lastName,
      email,
      messageFromCustomer,
      bookingId
    } = this.state;
    const bookingData = {
      selectedSlot,
    };

    return (
      <>
        {error ? (
          <ErrorPage message={error} />
        ) : (
          <>
            <Loader isShowLoader={isLoading} />
            <div className="container-fluid">
              <nav className="navbar navbar-expand-sm justify-content-center top_nav shadow">
                <a className="navbar-brand" href="#">
                  <img src={logo} alt="Logo" style={{ width: "100%" }} />
                </a>
              </nav>
            </div>
            <div className="main_div booking_main_row mt-4">
              <div className="left_div">
                <nav className="navbar side_navbar">
                  <ul className="navbar-nav side_bar_ul">
                    <li className="nav-item logo">
                      <img src={SideLogo} alt="logo" />
                    </li>
                    <li className="nav-item featured">
                      {!isEmpty(event) && (
                        <img
                          className="w-100"
                          src={
                            !isEmpty(event.event_image)
                              ? IMAGE_BASE_URL + event.event_image
                              : Three
                          }
                          alt="feature_img"
                        />
                      )}
                    </li>
                    <li className="nav-item">
                      <h2>{company.company_name}</h2>
                      <p>{company.company_description}</p>
                    </li>
                    <li className="nav-item">
                      <h2>Contact Details</h2>
                      <p className="sub_head">
                        <span>Email:</span> <br />
                        {company.company_email}
                      </p>
                      <p className="sub_head">
                        <span>Phone No:</span> <br />
                        {company.company_phone_no}
                      </p>
                      <p className="sub_head">
                        <span>Address</span> <br />
                        {company.company_address}
                      </p>

                      <div className="row side_bar_foot_img_div">
                        <div className="col-12 side_bar_foot_logo_img">
                          <img src={SideBarFootLogo} />
                        </div>
                      </div>
                    </li>
                  </ul>
                </nav>
              </div>
              <div className="right_div">
                {step === 1 && !isEmpty(event) && (
                  <BookingStep1
                    event={event}
                    specialRibbon={specialRibbon}
                    timezoneValue={timezoneValue}
                    onSelectTimzone={this.onSelectTimzone}
                    onSelectStaff={this.onSelectStaff}
                    onSelectSlot={this.onSelectSlot}
                    onSelectDate={this.onSelectDate}
                    onUpdateStep={this.onUpdateStep}
                  />
                )}
                {step === 2 && (
                  <BookingStep2
                    specialRibbon={specialRibbon}
                    timezoneValue={timezoneValue}
                    onSubmitStepTwo={this.onSubmitStepTwo}
                    onScheduleEvent={this.onScheduleEvent}
                    onUpdateStep={this.onUpdateStep}
                    event={event}
                    data={bookingData}
                  />
                )}
                {step === 3 && (
                  <BookingStep3
                    specialRibbon={specialRibbon}
                    onScheduleEvent={this.onScheduleEvent}
                    onUpdateStep={this.onUpdateStep}
                    onConfirmTempBooking={this.postConfirmTempBooking}
                    addOns={addOns}
                    pricing={pricing}
                    event={event}
                    firstName={firstName}
                    lastName={lastName}
                    email={email}
                    bookingId={bookingId}
                    messageFromCustomer={messageFromCustomer}
                    bookingDate={bookingDate}
                    selectedSlot={selectedSlot}
                    timezoneValue={timezoneValue}
                    paymentSettings={this.state.paymentSettings}
                  />
                )}
                {step === 4 && (
                  <BookingStep4
                    specialRibbon={specialRibbon}
                    timezoneValue={timezoneValue}
                    totalPrice={totalPrice}
                    event={event}
                    selectedSlot={selectedSlot}
                    endSlotTime={endSlotTime}
                    bookingDate={bookingDate}
                    guests={inviteeGuests}
                  />
                )}
              </div>
            </div>
          </>
        )}
      </>
    );
  }
}

export default connect(null, {
  getEvent,
  savePaidBooking,
  saveFreeBooking,
  sendPostRequest
})(withRouter(Booking));
